module.exports = __webpack_public_path__ + "static/shopmatic3-18352596ab9625cbc6b44ae8642be24d.png";